module.exports = __webpack_public_path__ + "img/15ab1a6.png";